export const generateOptionsFromEnum = <T extends Record<string, string>>(
    enumType: T
): { label: string, value: string }[] => {
    return Object.values(enumType).map((value: string) => ({
        label: value,
        value
    }));
};
